import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DropdownViewPointer = (props: SvgProps) => <Svg
  width='12'
  height='7'
  viewBox='0 0 12 7'
  fill='none'
  {...props}
>
  <Path
    d='M4.8 1.43333C5.4 0.633333 6.6 0.633334 7.2 1.43333L11 6.5H1L4.8 1.43333Z'
    fill='#B0CBE6'
    stroke='#B0CBE6'
  />
</Svg>;

export default DropdownViewPointer;
